export default {
  shootstaLearningAcademyURL: 'https://shootsta.com/resources/',

  planYourContentURL:
    'https://shootsta.com/learn/how-to-plan-a-successful-video/',

  shootYourVideoURL: 'https://shootsta.com/video-school/',

  getYourVideoEditedURL:
    'https://help.shootsta.com/en/collections/2034700-video-projects',

  shareYourMasterpieceURL:
    'https://help.shootsta.com/en/collections/2522193-sharing-and-collaborating-in-the-shootsta-hub',

  bookingCameraOperatorURL: 'https://bookings.shootsta.com/',
  professionalServicesURL: 'https://shootsta.com/professional-services/'
};
